import { IUsuarioxVideo } from "@/entities";

export class UsuarioXVideo implements IUsuarioxVideo {
  fkUsuario: number;
  fkVideo: number;
  aceptaDatos: boolean;
  aceptaNovedad: boolean;
  observaciones?: string;
  timezone: string;

  constructor() {
    this.fkUsuario = 0;
    this.fkVideo = 0;
    this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.aceptaDatos = false;
    this.aceptaNovedad = false;
    this.observaciones = "";
  }
}
